import styled from "styled-components";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

export const StyledAccordion = styled(Accordion)`
  background-color: ${(props) => props.theme.backgroundColor};
  &.Mui-expanded {
    background-color: ${(props) => props.theme.backgroundColor};
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: ${(props) => props.theme.backgroundColor};
  &.Mui-expanded {
    background-color: ${(props) => props.theme.backgroundColor};
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
    background-color: ${(props) => props.theme.backgroundColor};
`;

export const WrapperTickets = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  margin: 0 auto;
  margin-top: 15px;
  padding: 15px;
  max-width: 1000px;
  border-radius: 5px;
`;

export const DetailsCont = styled.div`
  display: flex;
  flex-direction: column;

  svg{
    margin-right: 8px;
  }
  .btn-container {
    margin-top: 20px;
  }
  p {
    margin-top: 15px;
    border-radius: 2px;
    padding-bottom: 12px;
    border-bottom: 1px solid #029f4361;
    display:flex;
    align-tems: center;
    vertical-align: middle;
  }

  a:hover {
    opacity: 0.7;
  }
  @keyframes gradient-border {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

a {
  color: rgb(255, 255, 255);
  text-decoration: none;
  align-self: end;
  border: 1px solid #245326b8;
  padding: 10px;
  border-radius: 5px;
  background-image: linear-gradient(45deg, rgb(2 206 88 / 0%), rgb(0 255 8 / 15%), rgb(57 192 186 / 0%));
  background-size: 200% 200%;
  animation: 3s ease 0s infinite normal none running gradient-border;
  box-shadow: 0px 0px 10px 1px #00cb543b;
  display: flex;
  align-tems:center;
  justify-content:center;
  vertical-align: middle;
  text-align: center;
}

`;

export const HeaderCont = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 20px;
  svg {
    margin-right: 8px;
  }

  p {
    display: flex;
    align-items: center;
  }
span {
  margin-left: auto;
}

  .green-circle {
    width: 10px;
    height: 10px;
    background: linear-gradient(45deg, rgb(37 37 37), rgb(20 20 20));
    border-radius: 50px;
    margin-right: 8px;
    border: none;
    box-shadow: rgba(0, 255, 31, 0.59) 0px 0px 4px;
    animation: 2s ease 0s infinite normal none running pulse ;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.8);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }
    70% {
      transform: scale(1.1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
    100% {
      transform: scale(1.0);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }

  .green-circle::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    background: linear-gradient(325deg, rgb(0 255 107), rgb(3 157 68),rgb(16 39 1));
    border-radius: 50px;
    top: -3px;
    left: -3px;
    z-index: -1;
    animation: 2s ease 0s infinite normal none running background;
  }

  @keyframes background {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }



  @keyframe circleAnimationBg {

  }
`;
